<template>
  <div>
    <div style="position: fixed; width: 100%; z-index: 1" class="white">
      <v-container fluid>
        <v-text-field
          flat
          autofocus
          clearable
          background-color="blue lighten-5"
          single-line
          hide-details
          prepend-icon="arrow_back"
          append-icon="search"
          @click:prepend="backToPrevious"
          @click:append="clickIconSearch"
          solo
          placeholder="Cari Event"
          v-model.lazy="onTypeSearch"
          @input="inputTextNya"
        ></v-text-field>
      </v-container>
    </div>
    <div style="padding-top: 72px">
      <v-container fluid class="pa-0">
        <div v-for="(item, i) in loadData" :key="i">
          <v-skeleton-loader type="list-item-two-line" :loading="loading">
            <v-list-item
              two-line
              ripple
              :to="{
                name: 'EventDetail',
                params: { slug: item.slug, id: item.id },
              }"
            >
              <v-list-item-content>
                <v-list-item-title class="text-truncate">{{
                  item.title
                }}</v-list-item-title>
                <v-list-item-subtitle class="text-truncate">
                  <v-chip x-small color="pink lighten-4" v-if="item.post_event"
                    >Berakhir</v-chip
                  >
                  {{ item.event_date }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-skeleton-loader>
        </div>
      </v-container>
    </div>
  </div>
</template>

<script>
import Axios from 'axios';

export default {
  name: 'Search',
  data() {
    return {
      onTypeSearch: null,
      loading: false,
      loadData: [],
    };
  },
  methods: {
    backToPrevious() {
      this.$router.push({ name: 'Home' });
    },
    inputTextNya() {
      this.loading = true;
      this.hitData(this.onTypeSearch);
    },
    clickIconSearch() {
      this.loading = true;
      this.hitData(this.onTypeSearch);
    },
    hitData(query) {
      Axios.get(
        process.env.VUE_APP_API + 'events?filter_date=all&search=' + query,
      )
        .then((response) => {
          this.loadData = response.data.data;
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => (this.loading = false));
    },
  },
};
</script>

<style scoped></style>
